module.exports = __webpack_public_path__ + "images/apple-touch-icon-167-3ddd79ca.png";